<template>
    <b-modal
      id="agAlertModal"
      class="agModal"
      ref="modal"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <template slot="modal-header">
        <h4 class="agModal-title" :class="messageClass">{{title}}</h4>
      </template>
      <p id="agAlertModal-message" :style="{ 'white-space': 'pre-wrap' }">
        {{message}}
      </p>
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonRight" variant="primary" @click="cancel">OK</b-button>
      </template>
    </b-modal>
</template>


<script>

// components


// modules


export default {
    name: "ag-alert-modal",

    components: {

    },

    props:{
      
    },

    data(){
        return {
            title: "",
            message: "",
            messageClass: "",
        };
    },

    computed: {

    },
    
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

      // UI Events


      // emitted Events


      // other

      show(title, message, type) {
        this.title = title;
        this.message = message;
        if(type == "error") {
          this.messageClass = "danger";
        }
        else {
          this.messageClass = "default";
        }
        
        setTimeout(() => {
          this.$refs.modal.show();
        }, 250);
      },

      hide() {
        this.$refs.modal.hide();
      },
    }
}

</script>






<style scoped lang="css">


#agAlertModal-message {
  width: 100%;
  max-height: 500px;
  word-wrap: break-word;
  white-space: pre-line;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/AlertModal.vue